import {
    USER_LOCALE
} from '../actions/types';
import { ENGLISH_LOCALE, SPANISH_LOCALE } from "../../languages";
import { getCurrentLanguage } from "../../helpers/language";

const lang = getCurrentLanguage();
const LOCALE = lang === 'es' ? SPANISH_LOCALE : ENGLISH_LOCALE;

localStorage.setItem('lang', lang);

const initialState = {
    ...LOCALE
};

export default function(state = initialState, action) {
    switch (action.type) {
        case USER_LOCALE:
            return {
                ...state,
                lang: action.payload.lang,
                messages: action.payload.messages,
            };
        default:
            return state;
    }
};
